import React, { useState, useEffect } from 'react';
import {
  getQuotationRequest,
  createReference,
  getReferenceAPI,
  deleteReference,
  getReferenceRequest,
  editReference,
  approveQuotation,
  createPurchaseOrder,
} from '../../services/vm/apiController';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { DeleteIcon, DownloadIcon, EditIcon } from './components/icons';
import { toast, ToastContainer } from 'react-toastify';
import { destroy } from '../../services/apiController';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Table, Row, Col, Modal, Button, Form, FloatingLabel, Alert } from 'react-bootstrap';
import PaginationInPage from '../Pagination';
import AlertIcon from '../../img.svg';

const QuotationDetail = (props) => {
  const [quotationDetail, setQuotationDetail] = useState({});
  let params = useParams();
  const [show, setShow] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [referenceForm, setReferenceForm] = useState({ name: '', contactNumber: '', comments: '', companyName: '' });
  const [purchaseOrderForm, setPurchaseOrderForm] = useState({
    purchaseNumber: '',
    vehicleName: '',
    amount: '',
    approvedDate: '',
    approvedBy: '',
    file1: null,
    file1Name: '',
    file2: null,
    file2Name: '',
    file3: null,
    file3Name: '',
  });
  const [validated, setValidated] = useState(false);
  const [referenceList, setReferenceList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [referenceName, setReferenceName] = useState('');
  const [approveBtnShow, setApproveBtnShow] = useState();
  const [documentShowConfirmModel, setDocumentShowConfirmModel] = useState(false);
  const [referenceShowConfirmModel, setReferenceShowConfirmModel] = useState(false);
  const handleCloseDocumentConfirmModal = () => {
    setDocumentShowConfirmModel(false);
  };
  const handleCloseReferenceConfirmModal = () => {
    setReferenceShowConfirmModel(false);
  };
  const [fieldToDeleted, setFieldToDeleted] = useState('');
  const [idToDeleted, setIdToDeleted] = useState('');
  const [quotId, setQuotId] = useState('');
  const [invalidFileType, setInvalidFileType] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  let navigate = useNavigate();

  const handleClose = () => {
    setShow(false);
  };
  const handleCloseModal = () => {
    setShowPurchaseModal(false);
  };
  const handleShow = () => {
    setShow(true);
    setReferenceForm({ name: '', contactNumber: '', comments: '', companyName: '' });
    setValidated(false);
  };
  const handleShowModal = () => {
    setShowPurchaseModal(true);
    setValidated(false);
  };

  const handleShowDocumentConfirmModal = (e, field) => {
    e.preventDefault();
    setDocumentShowConfirmModel(true);
    setFieldToDeleted(field);
  };
  const handleShowReferenceConfirmModal = (e, quotationId, referenceId) => {
    e.preventDefault();
    setReferenceShowConfirmModel(true);
    setIdToDeleted(referenceId);
    setQuotId(quotationId);
  };

  const deleteFile = (field) => {
    try {
      destroy(`/vm/vehicle-requests/${params.requestId}/quotations/${params.quotationId}/filefrom/${field}`)
        .then((resp) => {
          setQuotationDetail(resp.data);
          setDocumentShowConfirmModel(false);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };

  useEffect(() => {
    getSingleQuotation();
  }, []);

  const getSingleQuotation = async () => {
    const quotationVal = await getQuotationRequest(params.requestId, params.quotationId);
    setQuotationDetail(quotationVal.data);
    setPurchaseOrderForm({ ...purchaseOrderForm, vehicleName: quotationVal.data.VehicleRequest?.model, amount: quotationVal.data?.price });
  };

  const getReferenceList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, referenceId = 0) => {
    try {
      let condition = {
        name: referenceName || '',
      };
      const referenceList = await getReferenceAPI(offset, limit, condition, params.quotationId, referenceId);
      return referenceId === 0
        ? {
            data: (referenceList && referenceList.data.rows) || [],
            totalRecords: (referenceList && referenceList.data && referenceList.data.count) || 0,
          }
        : {
            data: (referenceList && referenceList.data) || [],
          };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  useEffect(() => {
    getReference();
  }, [currentPage]);

  const getReference = async () => {
    const listReference = await getReferenceList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listReference.totalRecords);
    setReferenceList(listReference.data);
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setReferenceForm({ ...referenceForm, [name]: value });
  };

  const handleChangePurchaseOrder = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };
  const onChangeDocumentOne = (e) => {
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setInvalidFileType(false);
      setPurchaseOrderForm({ ...purchaseOrderForm, file1: file || null, file1Name: file?.name || '' });
    }
  };

  const onChangeDocumentTwo = (e) => {
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setInvalidFileType(false);
      setPurchaseOrderForm({ ...purchaseOrderForm, file2: file || null, file2Name: file?.name || '' });
    }
  };

  const onChangeDocumentThree = (e) => {
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      setInvalidFileType(false);
      setPurchaseOrderForm({ ...purchaseOrderForm, file3: file || null, file3Name: file?.name || '' });
    }
  };

  const editReferenceRequest = async (e, id) => {
    e.preventDefault();
    const getSingleReference = async () => {
      const data = await getReferenceRequest(id, params.quotationId);
      setReferenceForm(data.data);
      setShow(true);
    };
    getSingleReference();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (referenceForm.id) {
      try {
        setIsButtonDisabled(false);
        await editReference(referenceForm, referenceForm.id, quotationDetail.id);
        toast.success('Reference updated successfully');
        setShow(false);
        getReference();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 2000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createReference(referenceForm, quotationDetail.id, params.requestId);
        toast.success('Reference added successfully');
        setShow(false);
        getReference();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 2000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleRemove = (event, quotationId, referenceId) => {
    event.preventDefault();
    const deleteRef = async () => {
      try {
        const data = await deleteReference(quotationId, referenceId);
        toast.success(data.data);
        setReferenceShowConfirmModel(false);
        getReference();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 2000 });
      }
    };
    deleteRef();
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    // Check if any required fields are empty
    if (
      !purchaseOrderForm.purchaseNumber ||
      !purchaseOrderForm.vehicleName ||
      !purchaseOrderForm.amount ||
      !purchaseOrderForm.approvedDate ||
      !purchaseOrderForm.approvedBy
    ) {
      toast.error('Please fill in all the required fields.');
      setApproveBtnShow(false);
      return;
    }

    // Check if at least two documents are selected
    const numDocumentsSelected =
      (purchaseOrderForm.file1 !== null ? 1 : 0) + (purchaseOrderForm.file2 !== null ? 1 : 0) + (purchaseOrderForm.file3 !== null ? 1 : 0);

    if (numDocumentsSelected < 2) {
      toast.error('Please select at least two documents.');
      setApproveBtnShow(false);
      return;
    }

    const formData = new FormData();
    for (var key in purchaseOrderForm) {
      if (key === 'file1' || key === 'file1Name' || key === 'file2' || key === 'file2Name' || key === 'file3' || key === 'file3Name') {
        continue;
      }
      formData.append(key, purchaseOrderForm[key]);
    }
    if (purchaseOrderForm.file1 !== null) formData.append('file1', purchaseOrderForm['file1'], purchaseOrderForm.file1Name);
    if (purchaseOrderForm.file2 !== null) formData.append('file2', purchaseOrderForm['file2'], purchaseOrderForm.file2Name);
    if (purchaseOrderForm.file3 !== null) formData.append('file3', purchaseOrderForm['file3'], purchaseOrderForm.file3Name);

    try {
      await createPurchaseOrder(formData, params.requestId, params.quotationId);
      setShowPurchaseModal(false);
      navigate('/vm/purchase-orders');
      getSingleQuotation();
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }

    try {
      await approveQuotation(params.requestId, params.quotationId);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/vm/vehicle-requests">Vehicle Request List</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/vm/vehicle-requests/${params?.requestId}`}>Vehicle Request Detail</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/vm/vehicle-requests/${params?.requestId}/quotations/${params.quotationId}`}>Quotation Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Quotation Detail
          </h4>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Vendor Name</dd>
              <dt className="display-value">{quotationDetail.name}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Price</dd>
              <dt className="display-value">{quotationDetail.price}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">GST #</dd>
              <dt className="display-value">{quotationDetail.gst}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Email</dd>
              <dt className="display-value">{quotationDetail.email}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Contact Person</dd>
              <dt className="display-value">{quotationDetail.contactPerson}</dt>
            </div>
          </Row>
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Vehicle Name</dd>
              <dt className="display-value">{quotationDetail?.VehicleRequest?.model}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Status</dd>
              <dt className="display-value">{quotationDetail.status}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Contact Number</dd>
              <dt className="display-value">{quotationDetail.contact}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Description</dd>
              <dt className="display-value">{quotationDetail.description}</dt>
            </div>
            <div className="col-md-3">
              <dd className="display-title mb-1">Address</dd>
              <dt className="display-value">{quotationDetail.address}</dt>
            </div>
          </Row>
          <Row>
            <Col xs={4}>
              <h6>Downloads</h6>
              <ul className="list-group">
                {quotationDetail.file1 !== null ? (
                  <li className="list-group-item">
                    <Row>
                      <Col xs={8} className="file-name">
                        {quotationDetail.fileName1}
                      </Col>
                      <Col xs={4} className="text-end actions">
                        <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${quotationDetail.file1}`}>
                          <DownloadIcon />
                        </a>
                        <DeleteIcon onClick={(e) => handleShowDocumentConfirmModal(e, 'file1')} />
                      </Col>
                    </Row>
                  </li>
                ) : (
                  ''
                )}
                {quotationDetail.file2 !== null ? (
                  <li className="list-group-item">
                    <Row>
                      <Col xs={8} className="file-name">
                        {quotationDetail.fileName2}
                      </Col>
                      <Col xs={4} className="text-end actions">
                        <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${quotationDetail.file2}`}>
                          <DownloadIcon />
                        </a>
                        <DeleteIcon
                          onClick={(e) => handleShowDocumentConfirmModal(e, 'file2')}
                          style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                        />
                      </Col>
                    </Row>
                  </li>
                ) : (
                  ''
                )}
              </ul>
            </Col>
            {quotationDetail.status === 'PENDING' && approveBtnShow !== false ? (
              <Col xs={5}>
                <div className="btn-wrapper">
                  <button type="button" onClick={handleShowModal} className="btn app-btn-primary mt-5">
                    Approve
                  </button>
                </div>
              </Col>
            ) : (
              ''
            )}
          </Row>
        </div>
      </div>
      <div className="row mb-2">
        <div className="form-group col-md-4 col-lg-4">
          <input
            type="text"
            className="form-control mt-5"
            id="exampleInputEmail1"
            placeholder="Please enter Name"
            aria-describedby="emailHelp"
            value={referenceName}
            onChange={(e) => {
              setReferenceName(e.target.value);
            }}
          />
        </div>
        <div className="form-group col-md-8 col-lg-8">
          <div className="btn-wrapper justify-content-start">
            <button type="button" className="btn app-btn-primary mt-5" onClick={getReference}>
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Reference
          </h4>
          <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
            Add Reference
          </button>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Comments</th>
                    <th>Company Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {referenceList?.map((request, index) => {
                    return (
                      <tr key={request.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>{request.name}</td>
                        <td>{request.contactNumber}</td>
                        <td>{request.comments}</td>
                        <td>{request.companyName}</td>
                        <td className="actions">
                          <span onClick={(event) => editReferenceRequest(event, request.id)}>
                            <EditIcon />
                          </span>
                          &nbsp;&nbsp;
                          <Link onClick={(e) => handleShowReferenceConfirmModal(e, quotationDetail.id, request.id)} to="/">
                            <DeleteIcon />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{!Object.keys(referenceForm).includes('id') ? 'Add Reference' : 'Edit Reference'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Reference Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={referenceForm.name}
                    className="input"
                    name="name"
                    type="text"
                    placeholder="Reference name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Contact" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={referenceForm.contactNumber}
                    className="input"
                    name="contactNumber"
                    type="text"
                    placeholder="Contact"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Comments" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={referenceForm.comments}
                    className="input"
                    name="comments"
                    type="text"
                    placeholder="Comments"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="Company Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={referenceForm.companyName}
                    className="input"
                    name="companyName"
                    type="text"
                    placeholder="Company Name"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3">
              {!Object.keys(referenceForm).includes('id') ? 'Add Reference' : 'Update Reference'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showPurchaseModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Purchase Order</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Purchase Number" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.purchaseNumber}
                    className="input"
                    name="purchaseNumber"
                    type="text"
                    placeholder="Purchase Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Vehicle Name" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.vehicleName}
                    className="input"
                    name="vehicleName"
                    type="text"
                    placeholder="Vehicle Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Amount" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.amount}
                    className="input"
                    name="amount"
                    type="text"
                    placeholder="Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved Date" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    className="input"
                    name="approvedDate"
                    value={purchaseOrderForm.approvedDate}
                    onChange={handleChangePurchaseOrder}
                    type="date"
                    placeholder="Approved Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Name of the Approver"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>PO Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control required onChange={onChangeDocumentOne} type="file" name="file1" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control required onChange={onChangeDocumentTwo} type="file" name="file2" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control onChange={onChangeDocumentThree} type="file" name="file3" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleApprove} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={documentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deleteFile(fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={referenceShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Reference</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseReferenceConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(event) => handleRemove(event, quotId, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default QuotationDetail;
